export default [{
  path: '/ForumProcess',//参会流程
  name: 'processFPage',
  component: () => import('@/view/Forum/process.vue')
},{
  path: '/ForumService',//服务指南
  name: 'serviceFPage',
  component: () => import('@/view/Forum/service.vue')
},{
  path: '/ForumServicePdf',//服务指南详情
  name: 'spdfFPage',
  component: () => import('@/view/Forum/pdf.vue')
},{
  path: '/ForumDataList',//会议动态
  name: 'DataListPage',
  component: () => import('@/view/Forum/DataList.vue')
},{
  path: '/ForumDataListDet',//会议动态详情
  name: 'DataListDetPage',
  component: () => import('@/view/Forum/DataListDet.vue')
},{
  path: '/ForumContact',//联络会议组
  name: 'contactFPage',
  component: () => import('@/view/Forum/contact.vue')
},
// {
//   path: '/ForumGuest',//嘉宾风采
//   name: 'guestFPage',
//   component: () => import('@/view/Forum/guest.vue')
// },{
//   path: '/ForumGuestDet',//嘉宾风采详情
//   name: 'guestDetFPage',
//   component: () => import('@/view/Forum/guestDetail.vue')
// },
]




// WEBPACK FOOTER //
// ./src/router/Forum.js